import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import "./Personas.scss";
import { auth } from "../../firebase";
import Footer from "../../components/Footer";
import Button from "../../components/Button";
import Persona from "../../components/Persona";
import { IPersona, IPersonaCategories } from "../../utils/types";
import { usePersonasContext } from "../../contexts/PersonasContext";
import { updatePersonas } from "../../helpers/update-personas";
import { personasData } from "../../utils/personas/personas";
import Loader from "../../components/Loader";

const xidBlackLogo = require("../../assets/black-logo.png");
const xidWhiteLogo = require("../../assets/white-logo.png");

export const Personas = () => {
  const [user, loading] = useAuthState(auth);
  const [isMobile, setIsMobile] = useState(false);
  const [selectedFirstLevelIds, setSelectedFirstLevelIds] = useState([-1]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedSecondLevelIds, setSelectedSecondLevelIds] = useState<
    {
      personaId: number;
      childrenPersonaIds: number[];
    }[]
  >([]);
  const [currentId, setCurrentId] = useState(-1);
  const [showSecondLevel, setShowSecondLevel] = useState(false);
  const [personas, setPersonas] = useState<IPersona[]>([]);
  const { setSelectedPersonas } = usePersonasContext();
  const navigate = useNavigate();

  const handleResize = () => {
    if (window.innerWidth <= 1200) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  const next = () => {
    !showSecondLevel && setShowSecondLevel(true);

    if (currentId === -1 && selectedFirstLevelIds.length > 1) {
      setCurrentId(selectedFirstLevelIds[1]);
      return;
    } else if (
      currentId > -1 &&
      currentId !== selectedFirstLevelIds[selectedFirstLevelIds.length - 1]
    ) {
      setCurrentId(
        selectedFirstLevelIds[selectedFirstLevelIds.indexOf(currentId) + 1]
      );
      return;
    } else {
      setSelectedPersonas(selectedSecondLevelIds);
      navigate("/brands");
    }
  };

  const updatePersonasData = async () => {
    const {
      updatedPersonas,
      updatedFirstLevelIds,
      updatedSecondLevelIds,
    } = await updatePersonas(personasData, user?.uid || "");

    setPersonas(updatedPersonas);
    setSelectedFirstLevelIds([
      ...selectedFirstLevelIds,
      ...updatedFirstLevelIds,
    ]);
    setSelectedSecondLevelIds(updatedSecondLevelIds);
    setIsLoading(false);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
  });

  useEffect(() => {
    if (loading) return;
    if (!user) return navigate("/");
    updatePersonasData();
  }, [user, loading]);

  const saveFirstPersona = (persona: IPersona) => {
    {
      const id = persona.id;
      persona.isSelected = !persona.isSelected;
      if (!selectedFirstLevelIds.includes(id)) {
        setSelectedFirstLevelIds([...selectedFirstLevelIds, id]);
        setSelectedSecondLevelIds([
          ...selectedSecondLevelIds,
          {
            personaId: id,
            childrenPersonaIds: [],
          },
        ]);
      } else {
        const index = selectedFirstLevelIds.indexOf(id);
        const secondLevelIndex = selectedSecondLevelIds.findIndex((object) => {
          return object.personaId === id;
        });
        selectedFirstLevelIds.splice(index, 1);
        selectedSecondLevelIds.splice(secondLevelIndex, 1);

        setSelectedFirstLevelIds([...selectedFirstLevelIds]);
        setSelectedSecondLevelIds([...selectedSecondLevelIds]);
      }
    }
  };

  const saveSecondPersona = (persona: IPersonaCategories) => {
    const id = persona.id;
    persona.isSelected = !persona.isSelected;

    const currentObject = selectedSecondLevelIds.find(
      (obj) => obj.personaId === currentId
    );

    if (currentObject && !currentObject?.childrenPersonaIds.includes(id)) {
      const updatedArray = selectedSecondLevelIds.map((obj) => {
        if (obj.personaId === currentObject.personaId) {
          obj.childrenPersonaIds.push(id);
        }
        return obj;
      });
      setSelectedSecondLevelIds([...updatedArray]);
    } else {
      const index = currentObject?.childrenPersonaIds.indexOf(id);
      const updatedArray = selectedSecondLevelIds.map((obj) => {
        if (obj.personaId === currentObject?.personaId) {
          index &&
            (obj.childrenPersonaIds.length > 1
              ? obj.childrenPersonaIds.splice(index, 1)
              : (obj.childrenPersonaIds = []));
        }
        return obj;
      });

      setSelectedSecondLevelIds([...updatedArray]);
    }
  };

  return (
    <div
      className={`row personas-page page-wrapper ${
        !isMobile ? "desktop-background-image" : ""
      }`}
    >
      <div className="col m4 header-container">
        {isMobile ? (
          <div className="mobile-header">
            <img src={xidWhiteLogo}></img>
          </div>
        ) : (
          <img src={xidBlackLogo}></img>
        )}
        <div className="text-header-bold">Make it yours</div>
        <div className="text-description">
          Customize your experiences and rewards <br />
          by chosing the topics you love.
        </div>
      </div>
      <div className={`col m4 ${!isMobile && "section-wrapper"}`}>
        {isLoading ? (
          <div className="loader">
            <Loader />
          </div>
        ) : (
          <div className="row personas-container">
            <div className="col m6">
              {!showSecondLevel
                ? personas.map((persona, index) => {
                    if (index < 3) {
                      return (
                        <div key={persona.name} className="btn-container">
                          <Persona
                            text={persona.name}
                            icon={persona.icon}
                            clicked={persona.isSelected}
                            onClick={() => saveFirstPersona(persona)}
                          ></Persona>
                        </div>
                      );
                    }
                  })
                : personas[currentId].categories.map((persona, index) => {
                    if (index < 3) {
                      return (
                        <div key={persona.name} className="btn-container">
                          <Persona
                            text={persona.name}
                            icon={persona.icon}
                            clicked={persona.isSelected}
                            onClick={() => saveSecondPersona(persona)}
                          ></Persona>
                        </div>
                      );
                    }
                  })}
            </div>
            <div className="col m6">
              {!showSecondLevel
                ? personas.map((persona, index) => {
                    if (index > 2) {
                      return (
                        <div key={persona.name} className="btn-container">
                          <Persona
                            text={persona.name}
                            icon={persona.icon}
                            clicked={persona.isSelected}
                            onClick={() => saveFirstPersona(persona)}
                          ></Persona>
                        </div>
                      );
                    }
                  })
                : personas[currentId].categories.map((persona, index) => {
                    if (index > 2) {
                      return (
                        <div key={persona.name} className="btn-container">
                          <Persona
                            text={persona.name}
                            icon={persona.icon}
                            clicked={persona.isSelected}
                            onClick={() => saveSecondPersona(persona)}
                          ></Persona>
                        </div>
                      );
                    }
                  })}
            </div>
          </div>
        )}
      </div>
      <div className="col m4 buttons-col">
        <div className="buttons-container">
          <Button
            size={isMobile ? "default" : "large"}
            className="btn-outlined"
            outline={true}
            onClick={next}
          >
            Skip
          </Button>
          <Button type="secondary" size="large" onClick={next}>
            Next
          </Button>
        </div>
        {!isMobile && <Footer />}
      </div>
    </div>
  );
};
